import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import QueryingRequestV2DefinitionPage from './RequestV2DefinitionPage';
import RequestV2DefinitionTabState from './RequestV2DefinitionTabState';

export default class RequestV2DefinitionTabView extends BufferTabView<RequestV2DefinitionTabState> {
  override render(): this {
    const props = {
      requestV2DefinitionId: this.model.get('requestV2DefinitionId'),
    };
    renderToDOM(
      <div
        className="react-tab-container"
        style={{display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: 0}}
      >
        <QueryingRequestV2DefinitionPage {...props} />
      </div>,
      this.el
    );
    return this;
  }

  override remove(): Backbone.View<RequestV2DefinitionTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

RequestV2DefinitionTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
